module.exports = __webpack_public_path__ + "img/shoplogo.a4ae2927.svg";